const styles = () => ({
  icon: {
    fontSize: 24,
    color: '#B0B7BC'
  }
});

export default styles;